import { httpsCallable } from 'firebase/functions';
import { functions } from './firebase';

export type SmartyAddressSuggestion = {
  streetLine: string;
  secondary?: string;
  city: string;
  state: string;
  postalCode: string;
  entries?: number;
  label: string;
};

export type SmartyVerifiedAddress = {
  addressLine1: string;
  addressLine2?: string;
  city: string;
  state: string;
  postalCode: string;
  deliverability: string;
  footnotes?: string;
};

export type SmartyVerificationResult = {
  verified: boolean;
  needsReview: boolean;
  message?: string;
  deliverabilityCode?: string;
  verifiedAddress?: SmartyVerifiedAddress;
  analysis?: {
    dpvMatchCode?: string;
    footnotes?: string;
  };
};

export async function fetchSmartyAddressSuggestions(query: string): Promise<SmartyAddressSuggestion[]> {
  const callable = httpsCallable(functions, 'getSmartyAddressSuggestions');
  const result = await callable({ query });
  return (((result.data as any)?.suggestions) || []) as SmartyAddressSuggestion[];
}

export async function verifySmartyAddress(input: {
  addressLine1: string;
  addressLine2?: string;
  city: string;
  state: string;
  postalCode: string;
}): Promise<SmartyVerificationResult> {
  const callable = httpsCallable(functions, 'verifySmartyAddress');
  const result = await callable(input);
  return ((result.data as any) || {}) as SmartyVerificationResult;
}
